module.exports = __webpack_public_path__ + "img/seguimiento_libros.0ac13779.svg";